<template lang="html">
    <div class="basic-info">
        <div class="preservation-jfxx" v-if="isShow('cdxx')">
            <Slogan theTitle="裁定信息"/>
            <van-cell-group>
                <van-field v-if="formData.sfcd != 1 "
                        v-model="formData.cdjg"
                        readonly
                        clickable
                        label="裁定结果"
                ></van-field>
                <div v-if="formData.sfcd == 1">
                    <van-field
                            v-model="formData.cCdjg"
                            readonly
                            clickable
                            label="裁定结果"
                            @click="toastJointCcxx(formData.cCdjg)"
                    ></van-field>
                    <van-field
                            v-model="formData.dtCdsj"
                            readonly
                            clickable
                            label="裁定日期"
                    ></van-field>
                    <ul v-show="formData.cCdjg !== '待裁定'" class="fd-file-content">
                        <li class="fd-cds-name" style="text-align: left; margin-bottom: -30px; color: #323233;">裁定文书</li>
                        <li class="fd-lh-50" v-if="!cdws.length">--</li>
                        <li class="fd-lh-50" v-else v-for="(item, index) in cdws"
                            :key="'cdws'+index"
                            @click="downloadCDWS(item)"
                            style="width: 100%;box-sizing: border-box;padding-left: 100px;word-break:break-all;">{{item.wsmc}}</li>
                    </ul>
                </div>
            </van-cell-group>
        </div>
        <div class="preservation-jfxx" v-if="isShow('bhxx')">
            <Slogan theTitle="驳回信息"/>
            <van-cell-group>
                <div v-if="cBqzt == 12">
                    <van-field
                            v-model="formData.cBhyy"
                            readonly
                            clickable
                            label="驳回原因"
                    ></van-field>
                    <van-field
                            v-model="formData.dtCdsj"
                            readonly
                            clickable
                            label="驳回日期"
                    ></van-field>
                </div>
            </van-cell-group>
        </div>
        <div class="preservation-jfxx" v-if="isShow('jfxx')">
            <Slogan theTitle="交费信息"/>
            <van-cell-group>
                <van-field
                        v-model="formData.jfzt"
                        readonly
                        clickable
                        label="交费状态"
                ></van-field>
                <div v-if="formData.nSfjf == 1">
                    <van-field
                            v-model="formData.cJfje"
                            readonly
                            clickable
                            label="交费金额"
                    ></van-field>
                    <van-field
                            v-model="formData.dtTzjfrq"
                            readonly
                            clickable
                            label="交费日期"
                    ></van-field>
                </div>
                <ul class="fd-file-content" v-if="formData.nSfjf&&formData.nSfjf!==3">
                    <li class="fd-cds-name" style="text-align: left; margin-bottom: -30px; color: #323233;">交费通知书</li>
                    <li class="fd-lh-50" v-if="!jftzs.length">--</li>
                    <li class="fd-lh-50" v-else v-for="(item, index) in jftzs"
                        :key="'jftzs'+index"
                        @click="downloadJFTZS(item)"
                        style="width: 100%;box-sizing: border-box;padding-left: 100px;word-break:break-all;">{{item.name}}</li>
                </ul>
            </van-cell-group>
        </div>
        <div class="preservation-shxx" v-if="isShow('shxx')">
            <Slogan theTitle="保全审核信息"/>
            <van-cell-group>
                <span style="font-size: 14px;padding-left: 10%;" v-if="formData.shz">{{formData.shz}}</span>
                <div v-else>
                    <van-field
                            v-model="formData.cShjg"
                            clearable
                            readonly
                            label="审核结果"
                    ></van-field>
                    <van-field
                            v-if="formData.cShyj!='' && formData.shjg == 3"
                            v-model="formData.cShyj"
                            readonly
                            clickable
                            @click="toastJointCcxx(formData.cShyj)"
                            label="审核退回原因"
                    ></van-field>
                    <van-field
                            v-if="formData.cShyj!='' && formData.shjg == 2"
                            v-model="formData.cShyj"
                            readonly
                            clickable
                            @click="toastJointCcxx(formData.cShyj)"
                            label="审核不通过原因"
                    ></van-field>
                    <van-field
                            v-model="formData.dtShsj"
                            readonly
                            clickable
                            label="审核日期"
                    ></van-field>
<!--                    审核结果为1通过的时候显示文件和备注信息项 -->
                    <template v-if="formData.shjg == 1">
                        <van-field
                            v-model="formData.wsmc"
                            readonly
                            clickable
                            label="文件"
                        ></van-field>
                        <van-field
                            v-model="formData.bz"
                            readonly
                            clickable
                            label="备注"
                        ></van-field>
                    </template>
                </div>
            </van-cell-group>
        </div>
<!--         如果存在审核数据 并且有变更担保审核信息 并且变更担保审核信息的审核状态存在，则展现变更担保审核信息 -->
        <app-preservation-preview-bgdb
            v-if="shxxData && shxxData.bgDbShxx && shxxData.bgDbShxx.shzt"
            :data="shxxData.bgDbShxx"></app-preservation-preview-bgdb>
<!--         如果存在审核数据 并且有补充担保审核信息 并且补充担保审核信息的审核状态存在，则展现补充担保审核信息 -->
        <app-preservation-preview-bcdb
            v-if="shxxData && shxxData.bcDbShxx && shxxData.bcDbShxx.shzt"
            :data="shxxData.bcDbShxx"></app-preservation-preview-bcdb>
<!--         如果存在审核数据 并且有续行保全审核信息 并且续行保全审核信息的审核状态存在，则展现续行保全审核信息 -->
        <app-preservation-preview-xxbq
            v-if="shxxData && shxxData.xxShxx && shxxData.xxShxx.shzt"
            :data="shxxData.xxShxx"></app-preservation-preview-xxbq>
<!--         如果存在审核数据 并且有解除审核信息 并且解除审核信息的审核状态存在，则展现解除保全审核信息 -->
        <app-preservation-preview-jcbq
            v-if="shxxData && shxxData.jcShxx && shxxData.jcShxx.shzt"
            :data="shxxData.jcShxx"></app-preservation-preview-jcbq>
        <div>
            <Slogan theTitle="保全基本信息"/>
            <van-cell-group>
                <van-field
                        v-model="basicData.cFymc"
                        clearable
                        readonly
                        label="申请法院"
                        @click="toastJointCcxx(basicData.cFymc)"
                ></van-field>
                <van-field
                        v-model="basicData.cBqlx"
                        readonly
                        clickable
                        label="保全类型"
                ></van-field>
                <van-field
                        v-model="basicData.cBqlb"
                        readonly
                        clickable
                        label="保全类别"
                ></van-field>
                <van-field
                        v-if="bqlb == 2"
                        v-model="basicData.cAhAjlxdz"
                        readonly
                        clickable
                        label="案件类型"
                        @click="toastJointCcxx(basicData.cAhAjlxdz)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2"
                        v-model="basicData.cAh"
                        readonly
                        clickable
                        label="案号"
                        @click="toastJointCcxx(basicData.cAh)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && (basicData.cAhAjlx == 1 || basicData.cAhAjlx == 2)"
                        v-model="basicData.cAy"
                        readonly
                        clickable
                        label="案由"
                        @click="toastJointCcxx(basicData.cAy)"
                ></van-field>
                <van-field
                    v-if="bqlb == 2 && basicData.cAhAjlx == 6"
                    v-model="cAyzt"
                    readonly
                    clickable
                    :label="ayLabel_1"
                    @click="toastJointCcxx(cAyzt)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && basicData.cAhAjlx == 6"
                        v-model="cAyxw"
                        readonly
                        clickable
                        :label="ayLabel_2"
                        @click="toastJointCcxx(cAyxw)"
                ></van-field>
                <van-field
                        v-if="bqlb == 2 && basicData.cAhAjlx == 6 && cAhNf >= 2021"
                        v-model="cXzaymc"
                        readonly
                        clickable
                        label="行政案由名称"
                        @click="toastJointCcxx(cXzaymc)"
                ></van-field>

                <van-field
                        v-if="bqlb == 1||bqlb == 4"
                        v-model="basicData.cFsqj"
                        readonly
                        clickable
                        label="非诉期间"
                        @click="toastJointCcxx(basicData.cFsqj)"
                ></van-field>
                <van-field
                        v-model="basicData.nSqbqje"
                        readonly
                        clickable
                        label="申请保全金额(元)"
                        @click="toastJointCcxx(basicData.nSqbqje)"
                ></van-field>
                <van-field
                        v-model="basicData.nSqbqdcsfy"
                        readonly
                        label="建议保全费(元)"
                        class="amount-ipt"
                        @click="toastJointCcxx(basicData.nSqbqdcsfy)"
                ></van-field>
                <van-field
                        v-model="basicData.cDbqk"
                        readonly
                        label="担保情况"
                ></van-field>
                <van-field
                        v-if="basicData.cDbqk == '无需担保'"
                        v-model="basicData.nWdbyy"
                        label="无需担保原因"
                        readonly
                        @click="toastJointCcxx(basicData.nWdbyy)"
                ></van-field>
                <van-field
                        v-model="basicData.cTjr"
                        readonly
                        class="amount-ipt"
                        label="提交人"
                ></van-field>
                <van-field
                            v-model="basicData.dtTjsj"
                            readonly
                            class="amount-ipt"
                            label="提交日期"
                    ></van-field>
                <van-field
                        v-model="basicData.cTjrlx"
                        readonly
                        label="提交人身份"
                ></van-field>
            </van-cell-group>
        </div>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    // 变更担保审核信息
    import appPreservationPreviewBgdb from './bgdb/index.vue';
    // 补充担保审核信息
    import appPreservationPreviewBcdb from './bcdb/index.vue';
    // 补充担保审核信息
    import appPreservationPreviewXxbq from './xxbq/index.vue';
    // 预览解除保全
    import appPreservationPreviewJcbq from './jcbq/index.vue';
    // 复议中请求js混入
    import request from "@/views/applyPreservation/mixins/request";
    import { Toast } from 'vant';
    import {typeBqlb, typeTjrlx, typeFsccFsqj, typeBqlx,typeAjlx,typeDbqk,typeWxdb,typeCdjg,typeTime,typeJfzt,typeShjg} from '../../../filters/index'
    import wx from 'weixin-js-sdk'
    export default {
        components: {
            Slogan,
            appPreservationPreviewBgdb,
            appPreservationPreviewBcdb,
            appPreservationPreviewXxbq,
            appPreservationPreviewJcbq
        },
        mixins: [request],
        // 注入
        inject: ['bqid'],
        data() {
            return {
                //基本信息
                basicData: {
                    cFymc: '', // 申请法院
                    cBqlx: '',//保全类型
                    cBxgsmc: '', // 担保机构
                    cBqlb: '', // 保全类别
                    nSqbqje: '', // 申请保全金额
                    nDbfy: '', // 担保费用
                    cFl: '', // 担保费率
                    nSqbqdcsfy:"",//建议保全费
                    cTjr: '', // 提交人
                    cTjrlx: '', // 提交人身份
                    cFsqj: '',//非诉期间
                    cAh: "",//案号
                    cAy: "",//案由
                    dtTjsj:"",
                    cDbqk:"",//担保情况
                    nWdbyy:"",//无需担保原因
                    cAhAjlx:"",//案件类型
                    cAhAjlxdz: ""//案件类型
                },
                //裁定信息
                formData: {
                    cBqzt: '',
                    cCdjg: '',
                    sfcd: '',
                    dtCdsj: '',
                    cBqlb: '',
                    cdjg: '待裁定',

                    //驳回原因
                    cBhyy:'',

                    //交费
                    jfzt: '',
                    nSfjf: '',
                    cJfje: '',
                    dtTzjfrq: '',
                    jftzs:'',//交费通知书

                    cShjg: '',
                    dtShsj: '',
                    cShyj: '',
                    shz: '',
                    shjg: '',
                    // 备注
                    bz: '',
                    // 文件名称
                    wsmc: ''
                },
                cAyzt:'',
                cAyxw:'',
                cXzaymc:'',
                cAhNf:'',
                bqlb: "",
                cBqzt:"",
                cdws: [],
                jftzs: [],

                ayLabel_1:'',
                ayLabel_2:'',
                // 审核信息
                shxxData: {}
            }
        },
        methods: {
            /* 下载裁定文书 */
            downloadCDWS(item){
                let url = item.url.split('?')
                let name = item.wsmc
                let left = url[0]
                let right = url[1]
                wx.miniProgram.navigateTo({
                    url: `/pages/downloadCL/downloadCL?name=${name}&left=${left}&${right}`
                })
            },
            /* 下载交费通知书 */
            downloadJFTZS(item){
                let url = item.url.split('?')
                let name = item.name
                let left = url[0]
                let right = url[1]
                wx.miniProgram.navigateTo({
                    url: `/pages/downloadCL/downloadCL?name=${name}&left=${left}&${right}`
                })
            },
            /* 下载交费通知书 */
            downloadShxxWj(name, url){
                let _url = url.split('?')
                let left = _url[0]
                let right = _url[1]
                wx.miniProgram.navigateTo({
                    url: `/pages/downloadCL/downloadCL?name=${name}&left=${left}&${right}`
                })
            },
            //获取裁定文书
            getCdws(){
                this.$axios.get('ssbq/api/sqbq/xq/cdws?lx=1&bqid='+ this.bqid).then(res => {
                    if(res.data.length){
                        this.cdws =res.data
                    }else{
                        this.cdws = []
                    }
                })
            },
            //获取交费通知书
            getJftzs(){
                this.$axios.get('ssbq/api/sqbq/jftzs?lx=1&bqid='+ this.bqid).then(res => {
                    if(res.data.length){
                        this.jftzs =res.data
                    }else{
                        this.jftzs = []
                    }
                })
            },
            toastJointCcxx(value){
                Toast(value);
            },
            getGuaranteeBasic() {
                // 保全id修改
                this.$axios.get('ssbq/api/bqsqinfo' + "?time=" + new Date().getTime() + "&bqid=" + this.bqid).then(res => {
                    //基本信息

                    let {cAhNf, nAjlx} = res.data;
                    var key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
                    if (key === 2020) {
                        this.ayLabel_1 = Number(nAjlx) === 6 ? '案由(主体类型)' : '案由';
                        this.ayLabel_2 = '案由(行为种类)';
                    } else {
                        this.ayLabel_1 = Number(nAjlx) === 6 ? '行政主体类型' : '案由';
                        this.ayLabel_2 = '行政案由';
                    }

                    this.cBqzt = res.data.cBqzt
                    this.bqlb = res.data.cBqlb
                    this.basicData.cFymc = res.data.cSqdyfymc
                    this.basicData.cBxgsmc = res.data.cBxgsmc
                    this.basicData.cBqlb = typeBqlb(res.data.cBqlb)
                    this.basicData.cBqlx = typeBqlx(res.data.cBqlx)
                    this.basicData.nSqbqje = res.data.nSqbqje
                    this.basicData.nDbfy = res.data.nDbfy
                    this.basicData.cFl = res.data.cFl
                    this.basicData.cTjr = res.data.cTjr
                    this.basicData.cAy = res.data.cAy
                    if(res.data.nAjlx == 6){
                            let ay = res.data.cAy.split(";");
                            this.cAyzt = ay[0];
                            let cAyzlarr = [];
                            ay.map((item, index) => {
                                if(index != 0){
                                    cAyzlarr.push(item)
                                }
                            })
                        if(key===2021){
                            this.cAyxw = res.data.cAyxzxwName;
                        }else{
                            this.cAyxw = cAyzlarr.join(";")
                        }
                        this.cXzaymc = res.data.cXzaymc;
                    }
                    this.cAhNf = cAhNf;
                    this.basicData.cAh = res.data.cBqah
                    this.basicData.nSqbqdcsfy = res.data.nSqbqdcsfy
                    this.basicData.cAhAjlx = res.data.nAjlx
                    this.basicData.cAhAjlxdz = typeAjlx(res.data.nAjlx)
                    this.basicData.dtTjsj = res.data.dtTjsj;
                    this.basicData.cDbqk = typeDbqk(res.data.cDbqk);
                    this.basicData.nWdbyy = typeWxdb(res.data.nWdbyy)
                    this.basicData.cFsqj = typeFsccFsqj(res.data.cFsqj)
                    this.basicData.cTjrlx = typeTjrlx(res.data.cTjrlx)
                    //裁定信息
                    let shxx = res.data;
                    if ("" != shxx.cCdjg) {
                        this.formData.sfcd = 1;
                        this.formData.cBqlb = shxx.cBqlb;
                        let str=`${shxx.cBqlb}_${shxx.cBqlx}_${shxx.cCdjg}`
                        this.formData.cCdjg=typeCdjg(str,shxx.cCdjg);
                        this.formData.cBqzt = shxx.cBqzt;
                        this.formData.dtCdsj = typeTime(shxx.dtCdsj);
                    }

                    //驳回原因
                    if(this.cBqzt==12){
                        this.formData.cBhyy=res.data.cBhyy;
                    }

                    //交费信息
                    console.log('--shxx.nSfjf 111',shxx.nSfjf);
                    this.formData.nSfjf = shxx.nSfjf;
                    if (1 == shxx.nSfjf) {
                        this.formData.cJfje = shxx.nJfje + "元";
                        this.formData.jfzt = typeJfzt(shxx.nSfjf);
                        this.formData.dtTzjfrq = typeTime(shxx.dtJfsj);
                        //交费通知书的逻辑判断
                    }
                    if(shxx.nSfjf != 1){
                         this.formData.jfzt = typeJfzt(shxx.nSfjf);
                    }
                    //审核信息
                    if (shxx.cBqzt == "2" || shxx.cBqzt == "10" ) {
                        this.formData.shz = "您提交的申请正在审核中，请耐心等待。";
                        return;
                    }
                    if (shxx.cBqzt != "2") {
                        // this.formData = shxx;
                        this.formData.shjg = shxx.cShjg;
                        this.formData.cShjg = typeShjg(shxx.cShjg);
                        this.formData.cShyj = shxx.cShyj;
                        if ("" == shxx.cShyj) {
                            this.formData.cShyj = "--";
                        }
                        this.formData.dtShsj = shxx.dtShsj;
                        // 审核备注
                        if(shxx.bz === 'null' || shxx.bz === 'undefined' ){
                            this.formData.bz = '--';
                        }else{
                            this.formData.bz = shxx.bz || '--';
                        }
                        // 文件名称
                        this.formData.wsmc = shxx.wsmc || '--';
                        return;
                    }
                })
            },

            /**
             * 获取审核信息数据
             * @returns {void}
             * */
            getShxxData() {
                // 请求审核信息
                this.requestShxx(this.bqid).then(data => {
                    // 赋值审核信息数据
                    this.shxxData = data;
                });
            },

            isShow(type){
                // 取消担保后详情页面展示  取消担保信息项 + 取消时保单状态对应的信息项(有可能是待审核或待交费)
                // 即涉及 2待审核, 3待交费状态的数据项需要判断一下 7取消状态是否显示
                // 保单信息
                if (type === "cdxx") {
                    return [6,7,9].includes(Number(this.cBqzt));
                }
                // 驳回信息
                if (type === "bhxx") {
                    return [12].includes(Number(this.cBqzt));
                }
                // 交费信息
                if (type === "jfxx") {
                     return [5,6,7,9,12].includes(Number(this.cBqzt));
                }
                // 审核信息
                if (type === "shxx") {
                    return [2, 3, 4, 5, 6,7,9,10,11,12,13,14,15].includes(Number(this.cBqzt));
                }
                // 解除保全-审核信息
                if (type === "jcbq-shxx") {
                    return [2, 3, 4, 5, 6,7,9,10,11,12,13,14,15].includes(Number(this.cBqzt));
                }
                return false;
            },
        },
        mounted() {
            this.getGuaranteeBasic()
            this.getCdws()
            this.getJftzs();
            // 获取审核信息数据
            this.getShxxData();
        }
    }
</script>

<style lang="less">
    .fd-file-content{
        position: relative;
        .fd-lh-50{
            text-align: right;
            padding-left: 18px;
            padding-right: 20px;
            line-height: 55px;
        }
        .fd-cds-name{
            padding-left: 18px;
            padding-right: 20px;
            position: absolute;
            line-height: 50px;
        }
    }
</style>
